const Alert = (props: { message: string, type?: string }) => {
    return (
        <div className={`alert alert--${props.type || 'error'}`} >
            <p>{props.message}</p>
        </div>
    );
};

export default Alert;
